import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { RetailerTypeRequest, RetailerTypesService } from '@src/app/shared/backend/clients';
import { ComboData } from '@src/app/shared/components/comboData/comboData';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-add-retailer-type',
    templateUrl: './add-retailer-type.component.html',
    styleUrl: './add-retailer-type.component.scss',
    host: {
        class: 'app-add-retailer-type'
    },
    standalone: false
})
export class AddRetailerTypeComponent extends BaseViewComponent implements OnInit {

  comboData: ComboData = new ComboData(async (filter) => await firstValueFrom(this.retailerTypesService.apiRetailerTypesFilterComboPost(filter)));

  public retailerTypeForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    code: ['', [Validators.required, Validators.maxLength(50)]],
    hasParentRetailerType: ['false'],
    retailerTypeId: [[]]
  },
    { validators: this.conditionalValidators() });

  constructor(
    private router: Router,
    private retailerTypesService: RetailerTypesService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    await this.initComboData();
  }

  async onLazyLoadComboData(event: any) {
    const search = event?.search?.trim() || null;
    const activePage = Math.max(1, (event?.pageIndex ?? 1));

    await this.comboData.getData(search, activePage);
  }

  private async initComboData() {
    await this.comboData.getData(null, 1);
  }

  getComboTotalPages(): number {
    const totalRecords = this.comboData?.totalRecords ?? 0;
    const pageSize = Number(this.comboData?.rowsPerPageOption) || 5;

    return Math.max(1, Math.ceil(totalRecords / pageSize));
  }

  conditionalValidators(): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const hasParentRetailerType = formGroup.get('hasParentRetailerType')?.value;
      const retailerType = formGroup.get('retailerTypeId')?.value;

      const hasSelectedRetailerType = Array.isArray(retailerType)
        ? retailerType.length > 0
        : !!retailerType;

      if (hasParentRetailerType === 'true' && !hasSelectedRetailerType) {
        return { requiredRetailerType: true };
      }

      return null;
    };
  }

  isRetailerTypeRequired(): boolean {
    return this.retailerTypeForm.get('hasParentRetailerType')?.value === 'true';
  }

  async submitForm() {
    if (this.retailerTypeForm.valid) {
      const payload: RetailerTypeRequest = {
        name: this.retailerTypeForm.controls['name'].value,
        code: this.retailerTypeForm.controls['code'].value,
        parentId: this.retailerTypeForm.controls['retailerTypeId'].value?.[0]
      };

      await firstValueFrom(this.retailerTypesService.apiRetailerTypesCreatePost(payload));

      this.retailerTypeForm.controls['name'].setValue(null);
      this.retailerTypeForm.controls['code'].setValue(null);
      this.retailerTypeForm.controls['retailerTypeId'].setValue([]);

      this.router.navigate(['/retailer-types']);
    }
  }
}
